<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 10px;">
    <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D; flex-shrink: 0;">person</mat-icon>
    <h2 style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">
      Detalle del beneficiario
    </h2>
  </div>
  <button type="button" (click)="onNoClick()"
    style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
    onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">close</mat-icon>
  </button>
</div>

<!-- Contenido -->
<div style="padding: 24px;">
  <div style="display: flex; flex-direction: column; gap: 14px;">

    <!-- Nombre -->
    <div style="display: flex; align-items: flex-start; gap: 12px; padding: 12px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0; margin-top: 1px;">person</mat-icon>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Nombre</span>
        <p style="margin: 2px 0 0; font-size: 0.9rem; font-weight: 700; color: #111827;">{{ data.nombre }}</p>
      </div>
    </div>

    <!-- Identificador -->
    <div style="display: flex; align-items: flex-start; gap: 12px; padding: 12px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0; margin-top: 1px;">alternate_email</mat-icon>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Identificador</span>
        <p style="margin: 2px 0 0; font-size: 0.9rem; font-weight: 700; color: #111827;">{{ data.identificador }}</p>
      </div>
    </div>

    <!-- Tipo de beneficiario -->
    <div style="display: flex; align-items: flex-start; gap: 12px; padding: 12px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0; margin-top: 1px;">{{ data.esEmpresa ? 'business' : 'person_outline' }}</mat-icon>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Tipo de beneficiario</span>
        <p style="margin: 2px 0 0; font-size: 0.9rem; font-weight: 700; color: #111827;">{{ data.esEmpresa ? 'Empresa' : 'Individuo' }}</p>
      </div>
    </div>

    <!-- Banco (si existe) -->
    <div *ngIf="data.banco?.nombre" style="display: flex; align-items: flex-start; gap: 12px; padding: 12px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0; margin-top: 1px;">account_balance</mat-icon>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Banco</span>
        <p style="margin: 2px 0 0; font-size: 0.9rem; font-weight: 700; color: #111827;">{{ data.banco.nombre }}</p>
      </div>
    </div>

    <!-- Número de cuenta (si existe) -->
    <div *ngIf="data.numeroCuenta" style="display: flex; align-items: flex-start; gap: 12px; padding: 12px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0; margin-top: 1px;">credit_card</mat-icon>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px;">Número de cuenta</span>
        <p style="margin: 2px 0 0; font-size: 0.9rem; font-weight: 700; color: #111827;">{{ data.numeroCuenta }}</p>
      </div>
    </div>

  </div>
</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end;">
  <button type="button" (click)="onNoClick()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Cerrar
  </button>
</div>
